export default __webpack_public_path__ + "static/media/notre-dame-de-lorette.2903da1c.jpg";